"use strict";

const attachContentNavListener = () => {
  const anchorEl = document.getElementById('rpc3-nav-secondary-anchor');
  const listEl = document.getElementById('rpc3-nav-secondary-list');

  if (!anchorEl || !listEl) {
    return;
  }

  anchorEl.addEventListener("click", () => {
    listEl.classList.toggle("nav-secondary-list-open");
  });

  anchorEl.classList.remove("uninitialized");
  listEl.classList.remove("uninitialized");
};

export default attachContentNavListener;
